import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { TeamVm } from './team.vm';

export const getTeam = async (teamId: string, callback: CallbackObject<TeamVm>) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res: AxiosResponse = await instance.get(`/management/teams/${teamId}`, config);
        callback.success(plainToClass(TeamVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
